import { getWebStorage } from '../../../../utils/storage';

import { EidState } from './eidState';

const FLOW_STATE_KEY = 'eid.flowState';
const CACHE_KEY = 'eid.verificationCache';

interface EidCache {
  assetIds: number[];
}

const defaultEidCache: EidCache = { assetIds: [] };

const getStorage = () => getWebStorage(window.sessionStorage);

const eidCache = (() => {
  try {
    const value = getStorage().getItem(CACHE_KEY);

    if (!value) {
      return defaultEidCache;
    }

    const decoded = JSON.parse(value) as EidCache;

    if (Array.isArray(decoded.assetIds)) {
      return decoded;
    }
  } catch {}

  return defaultEidCache;
})();

export const setEidFlowState = () => {
  const eidState = new EidState();

  const state = eidState.toBase64URL();

  getStorage().setItem(FLOW_STATE_KEY, state);

  return state;
};

const getEidFlowState = () => {
  const state = getStorage().getItem(FLOW_STATE_KEY);

  if (!state) {
    return undefined;
  }

  getStorage().removeItem(FLOW_STATE_KEY);

  return EidState.fromBase64URL(state);
};

const getEidQueryState = () => {
  const url = new URL(window.location.href);

  const state = url.searchParams.get('state');

  if (!state) {
    return undefined;
  }

  url.searchParams.delete('state');

  window.history.replaceState({}, '', url.pathname + url.search);

  return EidState.fromBase64URL(state);
};

export const verifyEidFlowState = (assetId: number) => {
  if (eidCache.assetIds.includes(assetId)) {
    return true;
  }

  const flowState = getEidFlowState();

  if (!flowState) {
    return false;
  }

  const queryState = getEidQueryState();

  const result = queryState?.token === flowState.token;

  if (result) {
    eidCache.assetIds.push(assetId);

    getStorage().setItem(CACHE_KEY, JSON.stringify(eidCache));
  }

  return result;
};
